import { toLower } from "lodash";
import { isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";

class Customer {
    firstName = null;
    firstNameLower = null;
    lastName = null;
    lastNameLower = null;
    middleName = null;
    suffix = null;

    gender = null;
    dateOfBirth = null;

    email = null;
    phone = null;

    socialSecurityNumber = null;

    constructor(customer) {
        if (isObjectNotEmpty(customer)) {
            if (isStringNotEmpty(customer.firstName)) {
                this.firstName = customer.firstName;
                this.firstNameLower = toLower(customer.firstName);
            }
            if (isStringNotEmpty(customer.lastName)) {
                this.lastName = customer.lastName;
                this.lastNameLower = toLower(customer.lastName);
            }
            if (isStringNotEmpty(customer.middleName)) { this.middleName = customer.middleName; }
            if (isStringNotEmpty(customer.suffix)) { this.suffix = customer.suffix; }

            if (isStringNotEmpty(customer.gender)) { this.gender = customer.gender; }
            if (isStringNotEmpty(customer.dateOfBirth)) { this.dateOfBirth = customer.dateOfBirth; }

            if (typeof customer.email === 'string' && isStringNotEmpty(customer.email)) { this.email = customer.email; }
            if (isStringNotEmpty(customer.phone)) { this.phone = customer.phone; }

            if (isStringNotEmpty(customer.socialSecurityNumber)) { this.socialSecurityNumber = customer.socialSecurityNumber; }
        }
    }

    toDto = () => {
        return {
            firstName: this.firstName,
            firstNameLower: this.firstNameLower,
            lastName: this.lastName,
            lastNameLower: this.lastNameLower,
            middleName: this.middleName,
            suffix: this.suffix,

            gender: this.gender,
            dateOfBirth: this.dateOfBirth,

            email: this.email,
            phone: this.phone,

            socialSecurityNumber: this.socialSecurityNumber
        };
    }
};

export default Customer;
